import type { CoreFetch } from '~/types/CoreFetch'
import type { Influencer } from '~/types/influencer'
import type { DeepPartial } from '~/types/utils'

export function providePatchCurator(coreFetch: CoreFetch) {
  return function (
    influencerId: Influencer['id'],
    patchObject: DeepPartial<Influencer>,
  ): Promise<Influencer> {
    return coreFetch.$patch(
      `/influencer/influencer/${influencerId}/`,
      patchObject,
    )
  }
}
